export enum SIDEBAR_MENU {
  MAIN = 'main', // 個人中心
  AGENT_MANAGEMENT = 'agentManagement', // 直屬代理管理
  PLAYER_MANAGEMENT = 'playerManagement', // 直屬會員管理
  STATION_REPORT = 'stationReport', // 投注站報表
  INVITATION_CODE_GENERATOR = 'invitationCodeGenerator', // 邀請碼管理
  DELEGATE_REPORT = 'delegateReport', // 代理報表
  PLAYER_REPORT = 'playerReport', // 會員報表
  COMMISSION_REPORT = 'commissionReport', // 佣金報表
  FUNDS_DETAILS = 'fundsDetails', // 資金明細
  STATION_EXCHANGE_RECORD = 'stationExchangeRecord', // 投注站兌換記錄
  STATION_QUOTA_CHANGE_LOG = 'stationQuotaChangeLog', // 現金額度報表
  RECHARGE_LIST = 'rechargeList', // 充值記錄
  WITHDRAW_LIST = 'withdrawList', // 提現記錄
  KYC = 'kyc', // 實名驗證
  BET_RECORD = 'betRecord', // 投注記錄
  SUB_ACCOUNT_MANAGEMENT = 'subAccountManagement', // 子帳號管理
  COMMISSION_WITHDRAWAL = 'commissionWithdrawal', // 佣金提現
  UPDATE_PASSWORD = 'updatePassword', // 密碼管理
  BETTING_BET_RECORD = 'bettingBetRecord', // 投注站投注記錄
  LANG = 'lang', // 換語系
}
